import React, { useEffect, useRef } from 'react';
import { useIntl, defineMessages } from 'react-intl';

import LoadingOverlay from 'components/common/LoadingOverlay';
import textToSpeechManager from 'support/tts/TextToSpeechManager';
import device from 'common/support/device';

const messages = defineMessages({
  loadingTts: {
    id: 'withLoading.tts',
    description: 'TTS for spinner',
  },
});

/**
 * Suspense fallback used while a lazily-loaded route chunk is still
 * downloading. Mirrors `WithLoading`'s "Loading" TTS announcement so users
 * relying on TTS still get feedback that something is happening, instead of
 * a silent spinner.
 */
const RouteLoadingFallback: React.FC = () => {
  const intl = useIntl();
  const focusRef = useRef<HTMLDivElement>(null);
  const loadingText = intl.formatMessage(messages.loadingTts);

  useEffect(() => {
    textToSpeechManager.add(loadingText);
    textToSpeechManager.speak();

    if (device.isVega) {
      focusRef.current?.focus({ preventScroll: true });
    }
  }, [loadingText]);

  return (
    <div
      ref={focusRef}
      tabIndex={device.isVega ? -1 : undefined}
      aria-label={device.isVega ? loadingText : undefined}
    >
      <LoadingOverlay />
    </div>
  );
};

export default RouteLoadingFallback;
